import React, {useEffect} from 'react';
import {useDispatch} from "react-redux";
import {useForm} from "react-hook-form";

import css from './SearchMenuInputModal.module.css';
import {availableDishesActions} from "../../../../store/slices/menu-slices";


const SearchMenuInputModal = () => {
    const dispatch = useDispatch();
    const {register, handleSubmit, setValue} = useForm();

    // Clear search on component unmount
    useEffect(() => {
        return () => {
            dispatch(availableDishesActions.clearSearch());
        };
    }, [dispatch]);

    const handleOnSubmit = (data) => {
        dispatch(availableDishesActions.filteredDishes(data.searchInput));
    }

    const handleClearSearch = () => {
        setValue('searchInput', '');
        dispatch(availableDishesActions.clearSearch());
    }


    return (
        <div className={css.wrap}>
            <form onChange={handleSubmit(handleOnSubmit)}>
                <input
                    type="text"
                    {...register('searchInput')}
                    placeholder="Search"
                    className={css.searchInput}
                />
                <button 
                    type="button" 
                    onClick={handleClearSearch}
                    className={css.clearButton}
                >
                    Clear
                </button>
            </form>
        </div>
    );
};

export {SearchMenuInputModal};